/* unplugin-vue-components disabled */import script from "./WorldOutlookPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WorldOutlookPage.vue?vue&type=script&setup=true&lang=js"

import "./WorldOutlookPage.vue?vue&type=style&index=0&id=d4876ef8&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4876ef8"]])

export default __exports__